<template>
  <div class="carousel">
    <!-- 父容器：row 栅格行 -->
    <section class="">
      <div
        id="carouselExampleCaptions"
        class="carousel slide"
        data-bs-ride="carousel"
        data-bs-interval="2000"
      >
        <div class="carousel-indicators">
          <button
            type="button"
            data-bs-target="#carouselExampleCaptions"
            data-bs-slide-to="0"
            class="active"
            aria-current="true"
            aria-label="Slide 1"
          ></button>
          <button
            type="button"
            data-bs-target="#carouselExampleCaptions"
            data-bs-slide-to="1"
            aria-label="Slide 2"
          ></button>
          <button
            type="button"
            data-bs-target="#carouselExampleCaptions"
            data-bs-slide-to="2"
            aria-label="Slide 3"
          ></button>
          <button
            type="button"
            data-bs-target="#carouselExampleCaptions"
            data-bs-slide-to="3"
            aria-label="Slide 4"
          ></button>
        </div>
        <div class="carousel-inner">
          <!-- 第一屏：储能供应链 -->
          <div class="carousel-item active">
            <img
              src="@/assets/images/cc/tg.gif"
              class="d-block w-100"
              alt="储能+算力协同供应链"
            />

            <div class="carousel-caption">
              <h5>{{ $t('tag1.title') }}</h5>
              <p>
                {{ $t('tag1.text') }}
              </p>
            </div>
          </div>
          <!-- 第一屏：储能供应链 -->
          <div class="carousel-item">
            <img
              src="@/assets/images/cc/tb.gif"
              class="d-block w-100"
              alt="储能全产业链供应链"
            />
            <div class="carousel-caption">
              <h5>{{ $t('tag1.title') }}</h5>
              <p>
                {{ $t('tag1.text') }}
              </p>
            </div>
          </div>
          <!-- 第二屏：数据中心产业链 -->
          <div class="carousel-item">
            <img
              src="@/assets/images/cc/tc.gif"
              class="d-block w-100"
              alt="数据中心算力供应链"
            />
            <div class="carousel-caption">
              <h5>{{ $t('tag2.title') }}</h5>
              <p>
                {{ $t('tag2.text') }}
              </p>
            </div>
          </div>
          <!-- 第三屏：双赛道协同优势 -->
          <div class="carousel-item">
            <img
              :src="$t('centerDataImg2')"
              class="d-block w-100"
              alt="储能全产业链供应链"
            />
            <div class="carousel-caption">
              <h5>{{ $t('tag3.title') }}</h5>
              <p>
                {{ $t('tag3.text') }}
              </p>
            </div>
          </div>
        </div>
        <button
          class="carousel-control-prev"
          type="button"
          data-bs-target="#carouselExampleCaptions"
          data-bs-slide="prev"
        >
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="visually-hidden">上一张</span>
        </button>
        <button
          class="carousel-control-next"
          type="button"
          data-bs-target="#carouselExampleCaptions"
          data-bs-slide="next"
        >
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="visually-hidden">下一张</span>
        </button>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'carousel',
  components: {},
  props: {
    msg: String,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
/* 轮播图高度统一，9:16竖图/全屏横幅可自行改 */
.carousel-item img {
  min-height: 300px;
  //object-fit: cover;
  border-radius: 10px;
}
/* 文字背景优化 */
.carousel-caption {
  background: rgba(0, 0, 0, 0.45);
  border-radius: 8px;
  padding: 20px 30px;
}
.powerText {
  padding: 3rem 0 0 0;
}

.left img {
  border-radius: 10px;
}
.right {
  padding: 20px 0 0 0;
}
</style>
